import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import v3Image from "../../assets/DoorAccess/elevatorStarterKit.jpg";
import image from "../../assets/product-list-assets/cameras/door-access/elevator-starter-kit.jpg";
import type { Product } from "../../types";
import { starterKits } from "../product-list-groups/starterKits";
import { touchPassSupport } from "../properties";
import { includedAccessories } from "../properties/includedAccessories";
import { includedHub } from "../properties/includedHub";
import { includedReaders } from "../properties/includedReaders";

export const elevatorStarterKit: Product = {
  id: "elevatorStarterKit",
  productTitle: "Elevator Starter Kit",
  description: "elevatorStarterKit.description",
  productListGroup: starterKits,
  descriptionMaxWidth: 280,
  techspecsPath: [SiteId.TechSpecs, "/unifi/door-access/ua-sk-elevator"],
  storePathParts: {
    category: "all-door-access",
    productSlug: "ua-sk-elevator",
  },
  image: { src: image, width: 200, height: 160 },
  v3Image: {
    src: v3Image,
    width: 328,
    height: 182,
  },
  propertyValues: [
    {
      propertyId: includedHub.id,
      value: {
        type: "translation",
        value: "elevatorStarterKit.includedHub",
      },
    },
    {
      propertyId: includedReaders.id,
      value: {
        type: "translation",
        value: "elevatorStarterKit.includedReaders",
      },
    },
    {
      propertyId: includedAccessories.id,
      value: {
        type: "translation",
        value: "elevatorStarterKit.includedAccessories",
      },
    },
    {
      propertyId: touchPassSupport.id,
      value: {
        type: "boolean",
        value: false,
      },
    },
  ],
};
